import { render, staticRenderFns } from "./HealthServiceDetail.vue?vue&type=template&id=32f5226d&scoped=true"
import script from "./HealthServiceDetail.vue?vue&type=script&lang=js"
export * from "./HealthServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./HealthServiceDetail.vue?vue&type=style&index=0&id=32f5226d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f5226d",
  null
  
)

export default component.exports